import { render, staticRenderFns } from "./CardSelector.vue?vue&type=template&id=167ac32f&"
import script from "./CardSelector.vue?vue&type=script&lang=js&"
export * from "./CardSelector.vue?vue&type=script&lang=js&"
import style0 from "./CardSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports